var _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    strokeWidth: 3,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M387.111,133.978v-10.003c0-15.845-12.891-28.735-28.735-28.735h-3.135v15.673h3.135c7.201,0,13.061,5.859,13.061,13.061 v58.514c0,7.201-5.86,13.061-13.061,13.061h-3.135v15.674h3.135c15.844,0,28.735-12.891,28.735-28.735v-10.004H512v-38.508 H387.111z M496.327,156.813H387.111v-7.161h109.216V156.813z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M313.445,61.803h-59.037h-7.837H70.142c-13.13,0-24.224,8.857-27.642,20.906c-15.687,0.185-28.394,12.996-28.394,28.726 v80.457c0,15.493,12.327,28.154,27.688,28.709c2.24,13.628,14.097,24.059,28.348,24.059h31.017L71.535,353.33H42.498 l-10.449,28.952H0v67.915h224.653v-67.915h-32.837l-10.449-28.952h-8.961l6.677-24.492h13.387c8.218,0,15.473-5.539,17.644-13.477 l4.306-15.802c1.509-5.546,0.373-11.346-3.116-15.911c-3.488-4.563-8.783-7.181-14.529-7.181h-3.416l8.671-31.807h44.542h7.837 h59.037c15.844,0,28.735-12.891,28.735-28.735V90.538C342.18,74.694,329.29,61.803,313.445,61.803z M41.407,204.872 c-6.53-0.717-11.628-6.261-11.628-12.978v-80.457c0-6.717,5.098-12.262,11.628-12.979V204.872z M208.98,397.956v36.568H15.673 v-36.568H208.98z M175.153,382.282H48.712l4.793-13.279h116.856L175.153,382.282z M156.161,353.33H87.78l29.624-108.669h68.381 L156.161,353.33z M196.775,292.14L196.775,292.14c1.125,0,1.784,0.642,2.076,1.024c0.294,0.383,0.742,1.19,0.446,2.276 l-4.303,15.792c-0.311,1.138-1.349,1.932-2.524,1.932h-9.115l5.731-21.023H196.775z M238.735,228.988H70.142 c-7.201,0-13.061-5.86-13.061-13.061V90.539c0-7.203,5.86-13.061,13.061-13.061h168.593V228.988z M326.507,215.927 c0,7.201-5.86,13.061-13.061,13.061h-59.037V77.478h59.037c7.201,0,13.061,5.859,13.061,13.061V215.927z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 74.71,
    y: 118.231,
    width: 15.673,
    height: 70.008
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 106.057,
    y: 118.231,
    width: 15.674,
    height: 70.008
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 137.404,
    y: 118.231,
    width: 15.673,
    height: 70.008
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrill);
export default __webpack_public_path__ + "static/media/drill.e4727130c03dfbefdf6c4798d94bb400.svg";
export { ForwardRef as ReactComponent };